module.exports = __webpack_public_path__ + "media/images/font/Gustavo-ThinItalic-1d55b862a2deb8dc09c320e9681d141f.ttf";